export default {
  computed: {
    headers () {
      return [
        {
          text: 'Módulo',
          value: 'acessoGrupoModulo',
          relation: 'modulo.titulo',
          filtros: []
        },
        {
          text: 'Descrição',
          value: 'descricao',
          filtros: []
        },
        {
          text: 'Identificação',
          value: 'identificacao',
          filtros: []
        },
        {
          text: 'Sequência',
          value: 'sequencia',
          filtros: []
        },
        {
          text: 'Ícone',
          value: 'icone',
          filtros: []
        },
        {
          text: 'Web Url',
          value: 'web_url',
          filtros: []
        },
        {
          text: 'Ativo',
          value: 'ativo',
          filtros: []
        }
      ]
    }
  }
}
